export default __webpack_public_path__ + "static/media/acControllerArrowIcon.43c05843.svg";